import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Switch, Table, Text } from "@pentabd/ui";

import { SelectedData } from "@helpers/watchSwitchGroups";
import { useGroups } from "@hooks/HRM/role-management/useGroups";

export const AssignGroupTable = () => {
  const { register, setValue, control } = useFormContext();
  const { groups } = useGroups();
  const { t } = useTranslation();

  return (
    <Table
      columns={[
        {
          id: 1,
          key: "name",
          name: t("POSITION.FORM.TABLE.ASSIGN_GROUP.COLUMN_NAME"),
          render: (data) => (
            <Text size="sm" weight="normal" color="subtitle1">
              {data}
            </Text>
          ),
        },
        {
          id: 2,
          key: "id",
          name: "",
          render: (id, row) => (
            <div className="d-flex justify-content-end pe-16">
              <Controller
                control={control}
                name={`groups.${id}`}
                render={({ field }) => {
                  return (
                    <Switch
                      {...register(`groups.${id}`)}
                      value={JSON.stringify(row)}
                      id={`groups.${id}`}
                      name="groups"
                      size="sm"
                      controlling
                      onChange={(e) => {
                        if (field.value) {
                          setValue(`groups.${id}`, false);
                        } else
                          setValue(`groups.${id}`, JSON.parse(e.target.value));
                      }}
                    />
                  );
                }}
              />
            </div>
          ),
        },
      ]}
      rows={groups}
      header={{
        badge: {
          label: `${
            SelectedData("groups") ? SelectedData("groups").length : 0
          }`,
          size: "sm",
          type: "primary",
        },
        title: t("POSITION.FORM.TABLE.ASSIGN_GROUP.HEADING"),
      }}
    />
  );
};
